<script>
export default {
    name: "AnaesthesiaNotes",

    data() {

        return {
            patient: {},
            procedure: {},
        };
    },

    mounted() {
        this.$root.loading=true;
        Promise.allSettled([ this.fetchAnaesthesiaNotes(), this.fetchPatient(), ]).then(() => {
            this.$root.loading=false;
            setTimeout(() => {
                window.print();
            }, 250);
        }).catch(() => { this.$root.loading=false; });
    },

    methods: {

        fetchPatient() {
            let url = `PatientRegistration/GetSpecificPatient`;
                url += `?PatientID=${this.$route.params.patientID}`;

            return this.$http.get(url).then(response => {
                this.patient = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },

        fetchAnaesthesiaNotes() {
            let url = `Theatre/GetAnaesthesiaNotesDetails`;
                url += `?ProcedureID=${this.$route.query.procedureId}`

            return this.$http.get(url).then(response => {
                this.procedure = response.data.length ? response.data[0] : {};
            }).catch(() => {});
        },
    },
}
</script>
<template>
    <div class="w-full flex flex-wrap p-1">
        <tail-address-header></tail-address-header>
        <div class="w-full flex flex-wrap my-3">
            <div class="flex-1">
                <h5 class="font-bold text-sm">Date: {{ procedure.trxDate | dateFormat }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold text-sm">Procedure: {{ procedure.procedure }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold text-sm">Done By: {{ procedure.notesBy }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold text-sm">Notes Recorded By: {{ procedure.userName }}</h5>
            </div>
        </div>
        <div class="w-full flex flex-wrap p-1 text-sm my-3">
            <div class="flex-1">
                <h5 class="font-bold">{{ patient.names }}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">IP NO: {{ patient.ipfileno || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">OP NO: {{ patient.opfileno || `-`}}</h5>
            </div>
            <div class="flex-1">
                <h5 class="font-bold">Visit No: {{ patient.visitNo || `-`}}</h5>
            </div>
        </div>
        <div class="w-full my-3 text-center">
            <h5 class="font-medium text-base uppercase">Anaesthesia Notes</h5>
        </div>
        <div class="w-full p-tiny">
            <span v-html="procedure.anaesthesiaNotes"></span>
        </div>
    </div>
</template>